module.exports = __webpack_public_path__ + "img/logo2.0afbfb7f.png";